(function () {
  var root = document.documentElement;
  root.classList.add('sr-js');

  // Reveal on scroll (content stays visible if this script never runs)
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  document.querySelectorAll('.sr-reveal').forEach(function (el) {
    io ? io.observe(el) : el.classList.add('is-in');
  });

  // Gallery: swipe track + dots
  document.querySelectorAll('[data-sr-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    var dots = g.querySelector('[data-dots]');
    if (!track || !dots) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' sur ' + slides.length);
      b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b);
    });
    var setActive = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
    setActive();

    // Mobile : la galerie prend presque tout l'écran, un glissement vertical doit donc faire défiler la page.
    // Le navigateur ne gère plus que le vertical (touch-action: pan-y dans sereine-refonte.css),
    // le glissement horizontal entre images est suivi ici.
    var sx = null, sy = 0, sl = 0, axis = null, snapTimer;
    var endDrag = function () {
      if (axis === 'x') {
        var w = track.clientWidth;
        var moved = track.scrollLeft - sl;
        var i = Math.round(sl / w);
        if (Math.abs(moved) > w * 0.15) i += moved > 0 ? 1 : -1;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; }, 500);
      }
      sx = null; axis = null;
    };
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { endDrag(); return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; sl = track.scrollLeft; axis = null;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (sx === null) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') { clearTimeout(snapTimer); track.style.scrollSnapType = 'none'; }
      }
      if (axis === 'x') track.scrollLeft = sl - dx;
    }, { passive: true });
    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });
  });

  // Delivery estimate: today + N business days (weekends skipped)
  var eta = document.querySelector('[data-eta]');
  if (eta && window.Intl) {
    var addBusinessDays = function (d, n) {
      var r = new Date(d);
      while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
      return r;
    };
    var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    var now = new Date();
    var a = addBusinessDays(now, parseInt(eta.dataset.min, 10) || 6);
    var b = addBusinessDays(now, parseInt(eta.dataset.max, 10) || 11);
    var span = eta.querySelector('span');
    if (span) span.textContent = 'Commande aujourd’hui, livraison estimée entre le ' + fmt.format(a) + ' et le ' + fmt.format(b);
  }

  // Product form: live price + sticky bar
  var form = document.getElementById('sr-pf');
  if (form) {
    var atcPrice = document.querySelector('[data-atc-price]');
    var stName = document.querySelector('[data-sticky-name]');
    var stPrice = document.querySelector('[data-sticky-price]');
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (r.name !== 'id') return;
      if (atcPrice) atcPrice.textContent = r.dataset.price;
      if (stName) stName.textContent = r.dataset.name + ' · ' + r.dataset.ship;
      if (stPrice) stPrice.textContent = r.dataset.price;
    });
    var checked = form.querySelector('input[name="id"]:checked');
    if (checked && stName) stName.textContent = checked.dataset.name + ' · ' + checked.dataset.ship;

    var atc = document.querySelector('[data-atc]');
    var sticky = document.querySelector('[data-sticky]');
    if (atc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        });
      }).observe(atc);
    }
  }

  // Une seule offre par commande (le fournisseur n'expédie qu'un article) :
  // choisir une offre remplace le contenu du panier au lieu de s'y ajouter.
  // Sans JavaScript, le panier bloque le paiement au-delà d'un article.
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!window.fetch || !f.closest('.sr-pdp, .sr-offers') || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var picked = f.querySelector('input[name="id"]:checked') || f.querySelector('input[name="id"]');
    var id = picked && parseInt(picked.value, 10);
    if (!id) return;
    e.preventDefault();
    Array.prototype.forEach.call(document.querySelectorAll('[type="submit"]'), function (b) { if (b.form === f) b.disabled = true; });
    var json = function (r) { if (!r.ok) throw r; return r.json(); };
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(json)
      .then(function (cart) {
        var updates = {};
        var replaced = false;
        cart.items.forEach(function (item) {
          updates[item.variant_id] = 0;
          if (item.variant_id !== id || item.quantity !== 1) replaced = true;
        });
        updates[id] = 1;
        return fetch(base + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(json).then(function () {
          var wasReplaced = replaced && cart.items.length > 0;
          // Tiroir panier si présent sur la page, sinon page panier
          if (window.SereineDrawer) {
            Array.prototype.forEach.call(document.querySelectorAll('[type="submit"]'), function (b) { if (b.form === f && !b.hasAttribute('data-sold-out')) b.disabled = false; });
            return window.SereineDrawer.open({ replaced: wasReplaced });
          }
          try { if (wasReplaced) sessionStorage.setItem('sr-replaced', '1'); } catch (err) {}
          window.location.href = base + 'cart';
        });
      })
      .catch(function () { f.submit(); });
  });
  // Retour arrière depuis le panier : réactiver les boutons
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.sr-pdp [type="submit"][disabled], .sr-offers [type="submit"][disabled]').forEach(function (b) {
      if (!b.hasAttribute('data-sold-out')) b.disabled = false;
    });
  });
})();
